/**
 * Vista: Lista de Productos No Conformes
 * Formato: AMX-CC-FR-05
 */

import calidadService from '../services/calidad.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';
import authService from '../services/auth.service.js';
import { abrirCatalogoDanos } from '../utils/catalogoDanosAdmin.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Productos No Conformes (PNC)</h2>
          <div style="display:flex;gap:0.5rem;flex-wrap:wrap;">
          ${authService.getUser()?.rol === 'admin' ? `<button class="btn btn-secondary" id="btnCatalogoDanos" title="Tipos de daño y ubicaciones que se eligen en Recepción">
            Catálogo de daños
          </button>` : ''}
          ${permisos.canCreate('pnc') ? `<button class="btn btn-primary" onclick="router.navigate('/calidad/pnc/nuevo')">
            + Nuevo PNC
          </button>` : ''}
          </div>
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total PNC</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPendientes" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Pendientes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCriticos" style="font-size: 1.5rem; font-weight: bold; color: var(--danger);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Críticos</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCerrados" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Cerrados</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statDanosPorCorregir" style="font-size: 1.5rem; font-weight: bold; color: #b45309;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Daños por corregir</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statDanosDiferidos" style="font-size: 1.5rem; font-weight: bold; color: #5b21b6;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Se corrigen con el pedido</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Descripción..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="estadoFilter" class="form-input">
              <option value="">Todos</option>
              <option value="abierto">Abierto</option>
              <option value="en_proceso">En Proceso</option>
              <option value="cerrado">Cerrado</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Acción</label>
            <select id="accionFilter" class="form-input">
              <option value="">Todas</option>
              <option value="concesion">Concesión</option>
              <option value="mantenimiento">Mantenimiento</option>
              <option value="reemplazo">Reemplazo</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Daños</label>
            <select id="danosFilter" class="form-input">
              <option value="">Todos</option>
              <option value="por_corregir">Por corregir</option>
              <option value="diferidos">Se corrigen con el pedido</option>
              <option value="concesion">Con concesión</option>
            </select>
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.pncListView.limpiarFiltros()" style="width: 100%;">
              Limpiar
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Daños</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="pncTableBody">
              <tr>
                <td colspan="4" style="text-align: center; padding: 2rem;">
                  Cargando PNC...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    // C-323d: catálogo del daño estructurado (sólo admin; el servidor también lo exige)
    document.getElementById('btnCatalogoDanos')?.addEventListener('click', () => abrirCatalogoDanos());
    if (!permisos.canView('pnc')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.pncListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarPNC();
      }, 500);
    });

    ['estadoFilter', 'accionFilter', 'danosFilter'].forEach(id => {
      document.getElementById(id).addEventListener('change', (e) => {
        const key = id.replace('Filter', '');
        if (e.target.value === '') {
          delete this.filters[key];
        } else {
          this.filters[key] = e.target.value;
        }
        this.currentPage = 1;
        this.cargarPNC();
      });
    });

    await this.cargarEstadisticas();
    await this.cargarPNC();
  },

  async cargarEstadisticas() {
    try {
      const response = await calidadService.obtenerEstadisticas();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.pnc?.total || 0;
      document.getElementById('statPendientes').textContent = stats.pnc?.pendientes || 0;
      document.getElementById('statCriticos').textContent = stats.pnc?.criticos_pendientes || 0;
      document.getElementById('statCerrados').textContent = stats.pnc?.cerrados || 0;
      document.getElementById('statDanosPorCorregir').textContent = stats.danos?.por_corregir ?? 0;
      document.getElementById('statDanosDiferidos').textContent = stats.danos?.diferidos ?? 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarPNC() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await calidadService.listarPNC(params);
      // La API devuelve { success, data: { pncs: [...], pagination: {...} } }
      const result = response.data || response;
      const pncs = result.pncs || (Array.isArray(result) ? result : []);
      const pagination = result.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderPNC(pncs);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar PNC');
      console.error('Error:', error);
      this.renderPNC([]);
    }
  },

  renderPNC(pncs) {
    const tbody = document.getElementById('pncTableBody');

    if (!pncs || pncs.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron productos no conformes
          </td>
        </tr>
      `;
      return;
    }

    const acciones = (p) => p.estado === 'cerrado'
      ? `${permisos.canView('pnc') ? `<button class="btn btn-sm btn-primary" onclick="window.pncListView.verDetalle(${p.id})">Ver</button>` : ''}`
      : `${permisos.canEdit('pnc') ? `<button class="btn btn-sm btn-primary" onclick="window.pncListView.verDetalle(${p.id})">Editar</button>` : ''}
         ${permisos.canDelete('pnc') ? `<button class="btn btn-sm btn-danger" onclick="window.pncListView.eliminarPNC(${p.id})">Eliminar</button>` : ''}`;

    const danoBadge = (p) => {
      const total = Number(p.total_problemas) || 0;
      const corregidos = Number(p.problemas_corregidos) || 0;
      if (total === 0) {
        return `<span style="color: var(--gray-500); font-size: 0.85rem; font-style: italic;">Sin daños registrados</span>`;
      }
      const completo = corregidos === total;
      const pct = total > 0 ? Math.round((corregidos / total) * 100) : 0;
      const color = completo ? '#10b981' : (corregidos > 0 ? '#f59e0b' : '#dc2626');
      const bgColor = completo ? '#d1fae5' : (corregidos > 0 ? '#fef3c7' : '#fee2e2');
      return `
        <div style="display:flex;align-items:center;gap:0.5rem;flex-wrap:wrap;">
          <span style="background:${bgColor};color:${color};padding:0.2rem 0.6rem;border-radius:999px;font-size:0.75rem;font-weight:700;">
            ${corregidos}/${total} corregidos
          </span>
          ${Number(p.problemas_por_corregir) > 0 ? `<span style="background:#fef3c7;color:#92400e;padding:0.15rem 0.5rem;border-radius:999px;font-size:0.72rem;font-weight:700;">${p.problemas_por_corregir} por corregir</span>` : ''}
          ${Number(p.problemas_diferidos) > 0 ? `<span style="background:#ede9fe;color:#5b21b6;padding:0.15rem 0.5rem;border-radius:999px;font-size:0.72rem;font-weight:700;">${p.problemas_diferidos} con el pedido</span>` : ''}
          ${Number(p.problemas_con_concesion) > 0 ? `<span style="background:#e0f2fe;color:#075985;padding:0.15rem 0.5rem;border-radius:999px;font-size:0.72rem;font-weight:700;">${p.problemas_con_concesion} con concesión</span>` : ''}
          <div style="flex:1;min-width:80px;max-width:120px;height:6px;background:var(--gray-200);border-radius:3px;overflow:hidden;">
            <div style="height:100%;width:${pct}%;background:${color};transition:width 0.3s;"></div>
          </div>
        </div>
      `;
    };

    tbody.innerHTML = pncs.map(p => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.pncListView.toggleRow(${p.id})">&#9654;</button>
        </td>
        <td><strong>${p.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${danoBadge(p)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(p)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-pnc-${p.id}">
        <td colspan="4" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Daños</dt><dd>${danoBadge(p)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs); flex-wrap: wrap;">
            ${acciones(p)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  toggleRow(pncId) {
    const detailRow = document.getElementById(`detail-pnc-${pncId}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  formatAccion(accion) {
    const acciones = {
      concesion: 'Concesión',
      mantenimiento: 'Mantenimiento',
      reemplazo: 'Reemplazo'
    };
    return acciones[accion] || accion || '-';
  },

  getAccionBadge(accion) {
    const badges = {
      concesion: 'badge-info',
      mantenimiento: 'badge-warning',
      reemplazo: 'badge-danger'
    };
    return badges[accion] || 'badge-secondary';
  },

  formatEstado(estado) {
    const estados = {
      abierto: 'Abierto',
      en_proceso: 'En Proceso',
      cerrado: 'Cerrado'
    };
    return estados[estado] || estado;
  },

  getEstadoBadge(estado) {
    const badges = {
      abierto: 'badge-warning',
      en_proceso: 'badge-info',
      cerrado: 'badge-success'
    };
    return badges[estado] || 'badge-secondary';
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.pncListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.pncListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.pncListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarPNC();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('estadoFilter').value = '';
    document.getElementById('danosFilter').value = '';
    document.getElementById('accionFilter').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarPNC();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-pnc-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      if (btn) btn.classList.toggle('expanded');
    }
  },

  verDetalle(id) {
    router.navigate(`/calidad/pnc/${id}`);
  },

  async eliminarPNC(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar este PNC (Producto No Conforme)? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await calidadService.eliminarPNC(id);
          toast.success('PNC eliminado');
          this.cargarEstadisticas();
          this.cargarPNC();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  }
};
